var checkboxBtnData = {
  name: 'checkboxBtn',
  data: [{
    radius: 4,
    height: 22,
    paddingLR: 8,
    // 左右padding
    fontSize: 12,
    shadow: '0 0 0 1px rgba(0, 0, 0, 0.15)',
    bgColor: '#fff',
    fontColor: '#5A6677',
    borderColor: '#D5DAE0',
    checkedBgColor: '#fff',
    checkedBorderColor: '#5365EA',
    checkedFontColor: '#5365EA'
  }]
};
export default checkboxBtnData;